import { truckloadShipmentStatusColors } from '../../../_shared/components/shipment/shipment-status-colors'
import { TShipmentMode, TShipmentStatus } from '../../../manage-shipments/data/types'
import {
  BooleanOperatorEnum,
  ConditionTypeEnum,
  MultiSelectOperatorEnum,
  NumberOperatorEnum,
  SingleSelectOperatorEnum,
  StringOperatorEnum
} from '../types'
import { TFieldOptions } from './field-options'

/**
 * Represents all fields available for autopilot rules for a shipment
 */
export const commonFieldOptions: TFieldOptions = {
  'carrier.chaineWorkspaceID': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'carrier.chaineWorkspaceID',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Carrier ID',
    value: 'carrier.chaineWorkspaceID'
  },
  'carrier.doNotUse': {
    defaultConditionsConfig: {
      comparison: {
        operator: BooleanOperatorEnum.TRUE
      },
      conditionName: 'carrier.doNotUse',
      conditionType: ConditionTypeEnum.Boolean
    },
    fieldType: ConditionTypeEnum.Boolean,
    name: 'Do not use carrier?',
    value: 'carrier.doNotUse'
  },
  'carrier.doNotUseReason': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'carrier.doNotUseReason',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Do not use carrier reason',
    value: 'carrier.doNotUseReason'
  },
  'carrier.dotNumber': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'carrier.dotNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'DOT number',
    value: 'carrier.dotNumber'
  },
  'carrier.mcNumber': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'carrier.mcNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'MC number',
    value: 'carrier.mcNumber'
  },
  'carrier.scac': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'carrier.scac',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'SCAC',
    value: 'carrier.scac'
  },
  'carrierSalesRep.id': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'carrierSalesRep.id',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Carrier Sales Rep',
    value: 'carrierSalesRep.id'
  },
  'carriers.companyName': {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: [],
        operator: MultiSelectOperatorEnum.HAS_ALL_OF
      },
      conditionName: 'carriers.companyName',
      conditionType: ConditionTypeEnum.MultiSelect
    },
    fieldType: ConditionTypeEnum.MultiSelect,
    name: 'Carrier name',
    value: 'carriers.companyName'
  },
  commodity: {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'commodity',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Commodity',
    value: 'commodity'
  },
  createdBy: {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'createdBy',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Created by',
    value: 'createdBy'
  },
  'customer.id': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'customer.id',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Customer ID',
    value: 'customer.id'
  },
  'customer.name': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'customer.name',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Customer name',
    value: 'customer.name'
  },
  'customerSalesRep.id': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'customerSalesRep.id',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Customer Sales Rep',
    value: 'customerSalesRep.id'
  },
  'dispatchers.email': {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: [],
        operator: MultiSelectOperatorEnum.HAS_ALL_OF
      },
      conditionName: 'dispatchers.email',
      conditionType: ConditionTypeEnum.MultiSelect
    },
    fieldType: ConditionTypeEnum.MultiSelect,
    name: 'Dispatcher Email',
    value: 'dispatchers.email'
  },
  'dispatchers.name': {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: [],
        operator: MultiSelectOperatorEnum.HAS_ALL_OF
      },
      conditionName: 'dispatchers.name',
      conditionType: ConditionTypeEnum.MultiSelect
    },
    fieldType: ConditionTypeEnum.MultiSelect,
    name: 'Dispatcher Name',
    value: 'dispatchers.name'
  },
  'distance.value': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'distance.value',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Distance',
    value: 'distance.value'
  },
  'driverMobileAppSettings.isCorrect': {
    defaultConditionsConfig: {
      comparison: {
        operator: BooleanOperatorEnum.TRUE
      },
      conditionName: 'driverMobileAppSettings.isCorrect',
      conditionType: ConditionTypeEnum.Boolean
    },
    fieldType: ConditionTypeEnum.Boolean,
    name: 'Are driver mobile app settings correct?',
    options: [
      { label: 'Correct', value: 'true' },
      { label: 'Incorrect', value: 'false' }
    ],
    value: 'driverMobileAppSettings.isCorrect'
  },
  'drivers.name': {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: [],
        operator: MultiSelectOperatorEnum.HAS_ALL_OF
      },
      conditionName: 'drivers.name',
      conditionType: ConditionTypeEnum.MultiSelect
    },
    fieldType: ConditionTypeEnum.MultiSelect,
    name: 'Driver Name',
    value: 'drivers.name'
  },
  'drivers.phoneNumber': {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: [],
        operator: MultiSelectOperatorEnum.HAS_ALL_OF
      },
      conditionName: 'drivers.phoneNumber',
      conditionType: ConditionTypeEnum.MultiSelect
    },
    fieldType: ConditionTypeEnum.MultiSelect,
    name: 'Driver Phone Number',
    value: 'drivers.phoneNumber'
  },
  equipment: {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: 'Van',
        operator: SingleSelectOperatorEnum.IS
      },
      conditionName: 'equipment',
      conditionType: ConditionTypeEnum.SingleSelect
    },
    fieldType: ConditionTypeEnum.SingleSelect,
    name: 'Equipment',
    value: 'equipment'
  },
  'financials.carrierInvoiceTotal': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'financials.carrierInvoiceTotal',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Carrier total invoice',
    value: 'financials.carrierInvoiceTotal'
  },
  'financials.carrierPaymentTotal': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'carrier.companyName',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Carrier total payment',
    value: 'financials.carrierPaymentTotal'
  },
  'financials.customerQuoteTotal': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'financials.customerQuoteTotal',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Customer total quote',
    value: 'financials.customerQuoteTotal'
  },
  'financials.marginInvoiced': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'financials.marginInvoiced',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Margin invoiced',
    value: 'financials.marginInvoiced'
  },
  'financials.marginPaid': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'financials.marginPaid',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Margin paid',
    value: 'financials.marginPaid'
  },
  'financials.marginQuoted': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'financials.marginQuoted',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Margin quoted',
    value: 'financials.marginQuoted'
  },
  hazmatIndicator: {
    defaultConditionsConfig: {
      comparison: {
        operator: BooleanOperatorEnum.TRUE
      },
      conditionName: 'hazmatIndicator',
      conditionType: ConditionTypeEnum.Boolean
    },
    fieldType: ConditionTypeEnum.Boolean,
    name: 'Is hazmat',
    value: 'hazmatIndicator'
  },
  hotLoadIndicator: {
    defaultConditionsConfig: {
      comparison: {
        operator: BooleanOperatorEnum.TRUE
      },
      conditionName: 'hotLoadIndicator',
      conditionType: ConditionTypeEnum.Boolean
    },
    fieldType: ConditionTypeEnum.Boolean,
    name: 'Is hot load',
    value: 'hotLoadIndicator'
  },
  isTracking: {
    defaultConditionsConfig: {
      comparison: {
        operator: BooleanOperatorEnum.TRUE
      },
      conditionName: 'isTracking',
      conditionType: ConditionTypeEnum.Boolean
    },
    fieldType: ConditionTypeEnum.Boolean,
    name: 'Is tracking',
    options: [
      { label: 'Is Tracking', value: 'true' },
      { label: 'Is Not Tracking', value: 'falsy' }
    ],
    value: 'isTracking'
  },
  proofOfDeliveryReceived: {
    defaultConditionsConfig: {
      comparison: {
        operator: BooleanOperatorEnum.TRUE
      },
      conditionName: 'proofOfDeliveryReceived',
      conditionType: ConditionTypeEnum.Boolean
    },
    fieldType: ConditionTypeEnum.Boolean,
    name: 'Proof of delivery received',
    options: [
      { label: 'Received', value: 'true' },
      { label: 'Pending', value: 'falsy' }
    ],
    value: 'proofOfDeliveryReceived'
  },
  'referenceNumbers.billOfLading': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'referenceNumbers.billOfLading',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Bill of lading',
    value: 'referenceNumbers.billOfLading'
  },
  'referenceNumbers.billingReferenceNumber': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'referenceNumbers.billingReferenceNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Billing reference #',
    value: 'referenceNumbers.billingReferenceNumber'
  },
  'referenceNumbers.externalTrackingID': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'referenceNumbers.externalTrackingID',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'External tracking #',
    value: 'referenceNumbers.externalTrackingID'
  },
  'referenceNumbers.orderNumber': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'referenceNumbers.orderNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Order number',
    value: 'referenceNumbers.orderNumber'
  },
  'referenceNumbers.pickupNumber': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'referenceNumbers.pickupNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Pickup number',
    value: 'referenceNumbers.pickupNumber'
  },
  'referenceNumbers.poNumber': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'referenceNumbers.poNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'PO number',
    value: 'referenceNumbers.poNumber'
  },
  'referenceNumbers.progressiveRotatingOrderNumber': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'referenceNumbers.progressiveRotatingOrderNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'PRO number',
    value: 'referenceNumbers.progressiveRotatingOrderNumber'
  },
  shipmentMode: {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: TShipmentMode.FTL,
        operator: SingleSelectOperatorEnum.IS
      },
      conditionName: 'shipmentMode',
      conditionType: ConditionTypeEnum.SingleSelect
    },
    fieldType: ConditionTypeEnum.SingleSelect,
    name: 'Shipment mode',
    value: 'shipmentMode'
  },
  shipmentNumber: {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'shipmentNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Shipment number',
    value: 'shipmentNumber'
  },
  shipmentStatus: {
    defaultConditionsConfig: {
      comparison: {
        expectedValue: TShipmentStatus.NeedsCarrier,
        operator: SingleSelectOperatorEnum.IS
      },
      conditionName: 'shipmentStatus',
      conditionType: ConditionTypeEnum.SingleSelect
    },
    fieldType: ConditionTypeEnum.SingleSelect,
    name: 'Shipment status',
    options: [
      {
        color: truckloadShipmentStatusColors[TShipmentStatus.NeedsCarrier],
        label: TShipmentStatus.NeedsCarrier,
        value: TShipmentStatus.NeedsCarrier
      },
      {
        color: truckloadShipmentStatusColors[TShipmentStatus.CarrierAssigned],
        label: TShipmentStatus.CarrierAssigned,
        value: TShipmentStatus.CarrierAssigned
      },
      {
        color: truckloadShipmentStatusColors[TShipmentStatus.InTransit],
        label: TShipmentStatus.InTransit,
        value: TShipmentStatus.InTransit
      },
      {
        color: truckloadShipmentStatusColors[TShipmentStatus.Delivered],
        label: TShipmentStatus.Delivered,
        value: TShipmentStatus.Delivered
      },
      {
        color: truckloadShipmentStatusColors[TShipmentStatus.Canceled],
        label: TShipmentStatus.Canceled,
        value: TShipmentStatus.Canceled
      }
    ],
    value: 'shipmentStatus'
  },
  specialInstructions: {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'specialInstructions',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Special instructions',
    value: 'specialInstructions'
  },
  teamRequired: {
    defaultConditionsConfig: {
      comparison: {
        operator: BooleanOperatorEnum.TRUE
      },
      conditionName: 'teamRequired',
      conditionType: ConditionTypeEnum.Boolean
    },
    fieldType: ConditionTypeEnum.Boolean,
    name: 'Team required',
    value: 'teamRequired'
  },
  temperatureControlled: {
    defaultConditionsConfig: {
      comparison: {
        operator: BooleanOperatorEnum.TRUE
      },
      conditionName: 'temperatureControlled',
      conditionType: ConditionTypeEnum.Boolean
    },
    fieldType: ConditionTypeEnum.Boolean,
    name: 'Temperature controlled',
    value: 'temperatureControlled'
  },
  'temperatureRange.max': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'temperatureRange.max',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Temperature maximum',
    value: 'temperatureRange.max'
  },
  'temperatureRange.min': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'temperatureRange.min',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Temperature minimum',
    value: 'temperatureRange.min'
  },
  'temperatureRange.runType': {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'temperatureRange.runType',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Temperature run type',
    value: 'temperatureRange.runType'
  },
  totalStops: {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'totalStops',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Total stops',
    value: 'totalStops'
  },
  trailerNumber: {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'trailerNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Trailer number',
    value: 'trailerNumber'
  },
  truckNumber: {
    defaultConditionsConfig: {
      comparison: {
        operator: StringOperatorEnum.IS
      },
      conditionName: 'truckNumber',
      conditionType: ConditionTypeEnum.String
    },
    fieldType: ConditionTypeEnum.String,
    name: 'Truck number',
    value: 'truckNumber'
  },
  'weight.value': {
    defaultConditionsConfig: {
      comparison: {
        operator: NumberOperatorEnum.EQUALS
      },
      conditionName: 'weight.value',
      conditionType: ConditionTypeEnum.Number
    },
    fieldType: ConditionTypeEnum.Number,
    name: 'Weight',
    value: 'weight.value'
  }
}
